module.exports = __webpack_public_path__ + "static/compound_interest_table-8ddb6305dc8871ff2715d4e649eac88c.png";